// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__bi-QY","infoBtn":"quickbooks_infoBtn__2JbvD","formBox":"quickbooks_formBox__11yGx","formFooter":"quickbooks_formFooter__3lo4_"};